module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "panel panel-default"
  }, [_vm._h('drug-view', {
    attrs: {
      "drug": _vm.drug,
      "patient": _vm.patient,
      "favs": _vm.favs,
      "id": _vm.modalId
    }
  }), " ", _vm._h('div', {
    staticClass: "panel-body"
  }, [_vm._l((_vm.favList), function(item) {
    return [(item) ? [_vm._h('div', {
      staticClass: "panel panel-default clickable",
      on: {
        "click": function($event) {
          _vm.launchModal(item)
        }
      }
    }, [_vm._h('div', {
      staticClass: "panel-heading"
    }, [_vm._h('div', {
      staticClass: "panel-title"
    }, [_vm._s(item.name)])]), " ", _vm._h('div', {
      staticClass: "panel-body"
    }, [_vm._h('ul', {
      staticClass: "list-group"
    }, [_vm._l((item.form), function(f) {
      return [_vm._l((f.dose), function(d) {
        return [(f.gen && d.val[0]) ? [_vm._h('li', {
          staticClass: "list-group-item"
        }, [_vm._s(f.mode) + " " + _vm._s(item.name) + " ", _vm._h('strong', [_vm._s(d.val[0]), (d.val[1]) ? _vm._h('span', [" - " + _vm._s(d.val[1])]) : _vm._e(), " " + _vm._s(d.unit)]), " ", (d.txt) ? _vm._h('span', [_vm._s(d.txt)]) : _vm._h('span', ["per dose"])])] : _vm._e()]
      })]
    })])])])] : _vm._e()]
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c0436e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/QuickView.vue
// module id = 146
// module chunks = 0